import { useTranslation } from 'react-i18next';

const KeyNumbersComponent = () => {
  const { t } = useTranslation();

  const numbers = [
    { num: t('homeMain.keyNum1'), label: t('homeMain.keyLabel1') },
    { num: t('homeMain.keyNum2'), label: t('homeMain.keyLabel2') },
    { num: t('homeMain.keyNum3'), label: t('homeMain.keyLabel3') },
    { num: t('homeMain.keyNum4'), label: t('homeMain.keyLabel4') },
  ];

  return (
    <div className="key-numbers">
      <div className="container">
        <div className="section-heading">
          <h2>{t('homeMain.keyTitle')}</h2>
          <p>{t('homeMain.keySubtitle')}</p>
        </div>
        <div className="numbers-row">
          {numbers.map((item, idx) => (
            <div className="number-card" key={`keynum-${idx}`}>
              <div className="num">{item.num}</div>
              <div className="num-label">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KeyNumbersComponent;
